import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY } from 'utils/constants/mediaQueries';

export const useIsMobileResolution = () => useMediaQuery(MEDIA_QUERY.maxWidth960);
